<ng-container *ngIf="isChatCreate">
  <button *ngIf="!isDefault; else defaultBtn" mat-icon-button color="accent" class="btn btn-primary" (click)="handleCreateChat()">
    <mat-icon svgIcon="add_circle" color="accent"></mat-icon>
  </button>
  <ng-template #defaultBtn>
    <button mat-raised-button color="accent" class="btn btn-primary" (click)="handleCreateChat()">
      {{ 'CLIENT.MESSENGER.CHAT_CREATE.SUBMIT' | translate }}
    </button>
  </ng-template>
</ng-container>
